export default "__VITE_ASSET__D1g43IS$__"